import React from 'react';
import LoungeHeading from "../../../components/LoungeHeading";
import { Link, useParams } from "react-router-dom";
import useFetchPages from "../../../hooks/useFetchPages";
import { spaceIdState } from "../../../state/spaceState";
import useFetchUser from "../../../hooks/useFetchUser";
import useTiming from "../../../hooks/useTiming";
import useUser from "../../../hooks/useUser";
import { useTranslation } from 'react-i18next';
import config from "../../../constants/config"
import { useFormatDate } from "../../../hooks/dates";
import useFetchTheatron from "../../../hooks/useFetchTheatron";

import LoungePages from "./LoungePages"
import { Route, useHistory, useRouteMatch } from "react-router-dom";
import Loading from "../../Loading";
import SEOHelmet from "../../../components/SEOHelmet";
import boothModeState from "../../../state/ui/boothModeState";
import { useRecoilValue } from "recoil";
import Footer from "../../../components/Footer";

const hoverClasses = 'transition-transform transform hover:scale-105 ease-in';

const LoungeItem = ({ title = '', url, image }) => {
  return (
    <Link to={url}>
      <div className={`relative rounded-2xl overflow-hidden backface-hidden z-10`}>
        <div className={`aspect-w-4 aspect-h-3 relative ${hoverClasses}`}>
          <div className="absolute top-0 left-0 bottom-0 right-0">
            <img src={image} className="w-full h-full object-cover"></img>
          </div>
        </div>
      </div>
      <div className="mt-1">
        <p className="text-white text-left capitalize text-sm ellipsis">{title}</p>
      </div>
    </Link>
  )
}

const LoungeHome = () => {
  const user = useUser();
  const timing = useTiming();
  const pages = useFetchPages();
  const { formatTime, format } = useFormatDate()
  const { t } = useTranslation(['lounge', 'booth'])
  const startsAt = formatTime(timing.starts_at);
  const startsAtDateTime = format(timing.starts_at);
  const theatron = useFetchTheatron();

  return (
    <div>
      <LoungeHeading title={timing.event.title}>
        <p className="text-gray-400 mb-8 text-left text-base lg:text-base md:text-sm dont-break-out">
          {t('lounge:welcome-user', { user: user?.name || '', app: theatron.data?.name, event: timing.event.title }) +
            ' ' + (timing.venue.type == 'vod' ? '' : t('lounge:show-starts-at', { starts: startsAt }))}
        </p>
      </LoungeHeading>
      <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-3 xl:gap-4">
        {pages.data && pages.data.map(item => <LoungeItem key={item.slug} title={item.title} image={item.cover} url={`/${timing.id}/${item.slug}`} />)}
      </div>
    </div>
  )
}

const BackButton = () => {
  const route = useRouteMatch({
    path: "/:timing",
  });

  const history = useHistory();

  const { t } = useTranslation('global')

  if (!route || route.isExact) {
    return null;
  }

  const onClick = (e) => {
    e.preventDefault();
    if (history.length > 1) {
      history.goBack();
    }
    else {
      history.go(route.url);
    }
  };

  return (
    <div className="btn-back-container">
      <button onClick={onClick} className="text-yellow-500 flex flex-row items-center md:mb-5">
        <i className="fas fa-fw fa-chevron-left text-base mr-1" />
        {t('back')}
      </button>
    </div>
  )
}

const HomeNavigation = () => {
  const user = useFetchUser();
  const timing = useTiming();

  const boothMode = useRecoilValue(boothModeState);

  if (user.isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex flex-col px-6 py-10 h-full">
      <BackButton />
      <SEOHelmet title={timing?.event?.title} />

      <Route path={"/:timing"} exact><LoungeHome /></Route>
      <Route path={"/:timing/:page"} exact><LoungePages /></Route>
      
      <Footer />
    </div>
  )
}


export default HomeNavigation;